import { render, staticRenderFns } from "./DetailsClient.vue?vue&type=template&id=6c62f71b&scoped=true&"
import script from "./DetailsClient.vue?vue&type=script&lang=js&"
export * from "./DetailsClient.vue?vue&type=script&lang=js&"
import style0 from "./DetailsClient.vue?vue&type=style&index=0&id=6c62f71b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c62f71b",
  null
  
)

export default component.exports